<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div v-show="isLoaded" class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Group</h4>
            <div v-if="action !== 'new'" class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ID</label>
              <label class="col-form-label col-lg-8">{{ createModel.id }}</label>
            </div>
            <validationObserver ref="addGroupForm">
              <!-- <form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset"> -->
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2">Sequence</label>
                <div class="col-lg-8">
                  <validationProvider
                    v-slot="{ errors }"
                    ref="sequence"
                    name="Sequence"
                    :rules="{
                      required: true,
                    }"
                  >
                    <b-form-input
                      id="sequence"
                      value="42"
                      type="number"
                      name="sequence"
                      v-model="createModel.sequence"
                      :class="{
                        'is-invalid': errors && errors.length,
                        'is-valid': !(errors && errors.length) && createModel.sequence,
                      }"
                    ></b-form-input>
                    <div v-if="errors && errors.length" class="invalid-feedback">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validationProvider>
                </div>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2">Name(EN)</label>
                <div class="col-lg-8">
                  <validationProvider
                    v-slot="{ errors }"
                    ref="displayname"
                    name="Display Name"
                    :rules="{
                      required: true,
                      duplicateName: [
                        isDuplicateEN,
                        'ชื่อ Group ภาษาอังกฤษห้ามซ้ำในระบบ',
                      ],
                    }"
                  >
                    <input
                      id="displayname"
                      name="displayname"
                      v-model="createModel.display_name"
                      type="text"
                      class="form-control"
                      placeholder="Name"
                      maxlength="30"
                      :class="{
                        'is-invalid': errors && errors.length,
                        'is-valid':
                          !(errors && errors.length) && createModel.display_name,
                      }"
                      v-on:keyup="onValidateDisplayname('en')"
                    />
                    <div v-if="errors && errors.length" class="invalid-feedback">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validationProvider>
                </div>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2">Name(TH)</label>
                <div class="col-lg-8">
                  <validationProvider
                    v-slot="{ errors }"
                    ref="displayname"
                    name="Display Name"
                    :rules="{
                      duplicateName: [isDuplicateTH, 'ชื่อ Group ภาษาไทยห้ามซ้ำในระบบ'],
                    }"
                  >
                    <input
                      id="displayname"
                      name="displayname"
                      v-model="createModel.display_name_th"
                      type="text"
                      class="form-control"
                      placeholder="Name"
                      maxlength="30"
                      :class="{
                        'is-invalid': errors && errors.length,
                        'is-valid':
                          !(errors && errors.length) && createModel.display_name_th,
                      }"
                      v-on:keyup="onValidateDisplayname('th')"
                    />
                    <div v-if="errors && errors.length" class="invalid-feedback">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validationProvider>
                </div>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2">Description</label>
                <div class="col-lg-8">
                  <input
                    id="group_description"
                    name="group_description"
                    v-model="createModel.group_description"
                    type="text"
                    class="form-control"
                    placeholder="Description"
                  />
                </div>
              </div>
              <div class="row">
                <label class="col-form-label col-lg-2">สถานะ</label>
                <div class="col-form-label col-lg-8">
                  <div class="row col-lg-12">
                    <b-form-radio
                      v-model="createModel.status"
                      name="status"
                      class="custom-control custom-radio custom-radio-info mb-3"
                      value="Active"
                      style="margin-right: 10px"
                      >Active</b-form-radio
                    >
                    <b-form-radio
                      v-model="createModel.status"
                      name="status"
                      class="custom-control custom-radio custom-radio-info mb-3"
                      value="Inactive"
                      style="margin-right: 10px"
                      >Inactive</b-form-radio
                    >
                  </div>
                </div>
              </div>
              <div v-show="hasRoleOptions" class="row">
                <label class="col-form-label col-lg-2">Roles</label>
                <div class="col-form-label col-lg-8">
                  <multiselect
                    v-model="roleSelected"
                    label="text"
                    track-by="value"
                    :options="roleOptions"
                    :multiple="true"
                  ></multiselect>
                </div>
              </div>
              <br />
              <div class="form-group mb-4 text-center">
                <div class="button-items">
                  <button type="button" class="btn btn-primary" @click="onSubmit">
                    Save
                  </button>
                  <button type="button" class="btn btn-secondary" @click="onConfirmReset">
                    Reset
                  </button>
                  <button type="button" class="btn btn-secondary" @click="onCancel()">
                    Cancel
                  </button>
                </div>
              </div>
              <!-- </form> -->
            </validationObserver>
          </div>

          <div v-if="action !== 'new'" class="card-body">
            <hr />
            <div class="row">
              <div class="col-lg-6">
                <h4 class="card-title mb-4">Group Cross Platform</h4>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-4 mr-4 text-right">
                  <div class="button-items">
                    <button
                      type="button"
                      class="btn btn-success"
                      @click="
                        gropCrossPlatform.toggleSideBar = !gropCrossPlatform.toggleSideBar
                      "
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <validationObserver ref="addGroupCrossPlatformForm">
              <div class="card-body">
                <b-table
                  v-bind:fields="groupCrossPlatformFields"
                  :items="groupCrossPlatform.applications"
                  class="table table-centered table-nowrap"
                  ref="grouptable"
                  :empty-text="'Not found any result'"
                  :show-empty="!isGroupCrossPlatform"
                  :bordered="true"
                >
                  <template #cell(index)="row">
                    <span>{{ row.index + 1 }}</span>
                  </template>
                  <template #cell(groups)="row">
                    <div style="width: 70%">
                      <b-button-group>
                        <b-button
                          v-for="group in row.item.groups"
                          :key="group.group_id"
                          variant="primary"
                          size="sm"
                          @click="
                            onConfirmDeleteGroupCrossPlatform(
                              row.item.application_id,
                              row.item.application_name,
                              group
                            )
                          "
                        >
                          {{ group.group_name }}
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </b-button-group>
                    </div>
                  </template>
                </b-table>
              </div>
            </validationObserver>
          </div>
        </div>
      </div>
    </div>
    <sideBar
      ref="sideBar"
      :toggleSideBar="gropCrossPlatform.toggleSideBar"
      :groupId="createModel.id"
      :groupName="createModel.display_name"
      :applicationGroupCrossPlatform="groupCrossPlatform.applications"
      @hidden="fnSideBarHidden"
    ></sideBar>
    <!-- end row -->
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import groupService from "@/helpers/service/group-provider";
import roleService from "@/helpers/service/role-provider";
import { eventBus } from "@/main.js";
import { StatusEnum } from "@/enum/group.enum.js";
import { applicationComputed } from "@/state/helpers";
import sideBar from "@/components/group-cross-platform/sideBar";
/**
 * Projects-create component
 */
export default {
  page: {
    title: "Create New Group",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, sideBar },
  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 120,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
      },
      id: "",
      action: "new",
      title: "Create New",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Group",
          href: "/Groups",
        },
        {
          text: "Create New",
          active: true,
        },
      ],
      createModel: {
        id: "",
        sequence: 0,
        display_name: "",
        display_name_old: "",
        display_name_th: "",
        display_name_th_old: "",
        status: StatusEnum.ACTIVE,
        roles: [],
      },
      isDuplicateEN: false,
      isDuplicateTH: false,
      roleOptions: [],
      roleSelected: [],
      isLoaded: false,
      gropCrossPlatform: {
        toggleSideBar: false,
      },
      groupCrossPlatform: {
        applications: [],
      },
      groupCrossPlatformFields: [
        {
          key: "index",
          label: "Index",
          thStyle: "width: 5%",
          sortable: true,
          tdClass: "text-center",
        },
        {
          key: "application_id",
          label: "Application Id",
          thStyle: "width: 10%",
        },
        {
          key: "application_name",
          label: "Application Name",
          thStyle: "width: 30%",
          sortable: true,
        },
        {
          key: "groups",
          label: "Groups",
        },
      ],
    };
  },
  computed: {
    ...applicationComputed,
    hasRoleOptions() {
      return this.$validate.anyArrayObjectValid(this.roleOptions);
    },
    isGroupCrossPlatform() {
      return this.$validate.anyArrayObjectValid(this.groupCrossPlatform.applications);
    },
  },
  created() {
    this.id = this.$route.params.id;
    if (this.id === "new") {
      this.action = "new";
      this.title = "Create";
    } else {
      this.action = "edit";
      this.title = "Edit";
    }
  },
  mounted() {
    if (this.action === "edit") {
      this.loadData();
    } else {
      this.getRoleOptions();
      this.isLoaded = true;
    }
  },
  methods: {
    async loadData() {
      await this.getRoleOptions();
      await this.getDetail();
    },
    async getRoleOptions() {
      let result = await roleService.getRoleOptionsAsync(
        this.GET_APPLICATION_SELECTED.id
      );

      //   console.log("getRoleOptions", result);
      if (result.status === 200) {
        // this.createModel = result.data;
        this.roleOptions = result.data.map((item) => {
          let displayName = item.display_name.th || item.display_name.en;
          return { id: item.id, text: displayName, value: item.id };
        });
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async getDetail() {
      let result = await groupService.getGroupAsync(
        this.GET_APPLICATION_SELECTED.id,
        this.id
      );

      //    console.log(result);
      if (result.status === 200) {
        this.createModel = result.data;
        //  console.log('this.createModel', this.createModel)
        delete this.createModel.users;
        delete this.createModel.view_permissions;
        // console.log('this.createModel2', this.createModel)
        this.createModel.display_name_old = result.data.display_name;
        this.createModel.display_name_th_old = result.data.display_name_th;
        if (
          this.hasRoleOptions &&
          this.$validate.anyArrayObjectValid(this.createModel.roles)
        ) {
          this.roleSelected = this.roleOptions.filter((q) =>
            this.createModel.roles.includes(q.id)
          );
        }
        await this.getGroupCrossPlatform();
        this.isLoaded = true;
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
        this.$router.push({ path: "/Groups" });
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async getGroupCrossPlatform() {
      let result = await groupService.getGroupCrossPlatformAsync(
        this.GET_APPLICATION_SELECTED.id,
        this.id
      );
      if (
        result.status === 200 &&
        this.$validate.isObjectKeyValid(result.data, "applications")
      ) {
        this.groupCrossPlatform.applications = result.data.applications;
      } else if (result.response.status === 404) {
        this.groupCrossPlatform.applications = [];
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async onSubmit() {
      this.$refs.addGroupForm.validate().then(async (result) => {
        if (result) {
          if (this.$validate.anyArrayObjectValid(this.roleSelected)) {
            this.createModel.roles = this.roleSelected.map((item) => item.value);
          } else {
            this.createModel.roles = [];
          }

          // console.log("this.createModel", this.createModel);
          if (this.action === "new") {
            let result = await groupService.createGroupAsync(
              this.GET_APPLICATION_SELECTED.id,
              this.createModel
            );
            if (result.status === 201) {
              // eventBus.$emit("info-modal", "เพิ่มข้อมูลสำเร็จ");
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              this.$router.push({
                path: "/Groups",
              });
              // this.clearForm();
            } else {
              eventBus.$emit("error-modal", result.response.data.message);
            }
          } else {
            let result = await groupService.updateGroupAsync(
              this.GET_APPLICATION_SELECTED.id,
              this.id,
              this.createModel
            );
            if (result.status == 204) {
              // eventBus.$emit("info-modal", "แก้ไขข้อมูลสำเร็จ");
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              this.$router.push({
                path: "/Groups",
              });
            } else {
              eventBus.$emit("error-modal", result.response.data.message);
            }
          }
        }
      });
    },
    onConfirmReset() {
      this.$utils
        .confirmAlertDisplay(`ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`, "")
        .then((result) => {
          if (result) {
            // console.log("mode", this.mode);
            if (this.action === "new") {
              this.createModel = {
                id: 0,
                sequence: 0,
                display_name: "",
                display_name_old: "",
                display_name_th: "",
                display_name_th_old: "",
                status: StatusEnum.ACTIVE,
              };
              this.$nextTick(
                () => this.$refs.addGroupForm.reset(),
                this.$refs.addGroupForm.$children[0].reset()
              );
            } else {
              this.getDetail();
            }
          }
        });
    },
    onCancel() {
      this.$router.push({
        path: "/Groups",
      });
    },
    async onValidateDisplayname(lang) {
      let display_name = "";
      let display_name_old = "";
      if (lang === "th") {
        display_name = this.createModel.display_name_th;
        display_name_old = this.createModel.display_name_th_old;
      } else {
        display_name = this.createModel.display_name;
        display_name_old = this.createModel.display_name_old;
      }

      // console.log('onValidateDisplayname', display_name, '-',display_name_old)
      if (this.$validate.isTrimValid(display_name)) {
        if (this.action === "edit" && display_name_old == display_name.trim()) {
          return;
        }
        let params = new URLSearchParams();
        params.append("display_name", display_name.trim());
        params.append("lang", lang);
        if (this.action !== "new") {
          params.append("id", this.id);
        }
        let result = await groupService.headGroupAsync(
          this.GET_APPLICATION_SELECTED.id,
          params
        );
        // console.log('onValidateDisplayname', result)
        if (result.status === 200) {
          if (lang === "th") {
            this.isDuplicateTH = true;
          } else {
            this.isDuplicateEN = true;
          }
        } else if (result.response.status === 404) {
          if (lang === "th") {
            this.isDuplicateTH = false;
          } else {
            this.isDuplicateEN = false;
          }
        } else {
          if (result.response.data.message) {
            eventBus.$emit("error-modal", result.response.data.message);
          } else {
            eventBus.$emit("error-modal", "Bad request: Unkonw error");
          }
        }
      }
    },
    clearForm() {
      this.createModel = {
        id: 0,
        id_od: "",
        display_name: "",
        display_name_th: "",
        status: StatusEnum.ACTIVE,
        ownGroupStatus: true,
        create_info: {
          timestamp: "",
          user_id: "",
          user_name: "",
        },
        update_info: {
          timestamp: "",
          user_id: "",
          user_name: "",
        },
      };
    },
    // Group Cross Platform
    async onAddGroupCrossPlatform() {
      this.$refs.addGroupForm.validate().then(async (result) => {
        if (result) {
          console.log("onAddGroupCrossPlatform");
        }
      });
    },
    async onConfirmDeleteGroupCrossPlatform(applicationId, applicationName, group) {
      this.$utils
        .confirmAlertDisplay(
          `ต้องการลบข้อมูล Group นี้ใช่หรือไม่`,
          `Group: <b>${group.group_name}</b> <br> Application: ${applicationName}`
        )
        .then(async (result) => {
          if (result) {
            // await this.removeGroupFromCrossPlatform(applicationId, group.group_id);
            // await this.updateGroupCrossPlatformByGroupId();
            await this.deleteGroupCrossPlatformByGroupId(applicationId, group.group_id);
          }
        });
    },
    async deleteGroupCrossPlatformByGroupId(applicationId, groupId) {
      let params = new URLSearchParams();
      params.append("application_id", applicationId);
      params.append("group_ids", groupId);

      let result = await groupService.deleteGroupCrossPlatformAsync(
        this.GET_APPLICATION_SELECTED.id,
        this.id,
        params.toString()
      );
      if (result.status === 200) {
        await this.getGroupCrossPlatform();
        eventBus.$emit("info-modal", "Group cross platform deletion successful");
      } else {
        eventBus.$emit("error-modal", result);
      }
    },
    async groupApplicationSelected() {
      const acc = new Map();
      for (const application of this.groupCrossPlatform.applications) {
        const applicationId = application.application_id;
        let groupIds = application.groups.map((group) => group.group_id);
        acc.set(applicationId, groupIds);
      }
      const applications = Array.from(acc, ([application_id, group_ids]) => ({
        application_id,
        group_ids,
      }));
      return { applications };
    },
    async fnSideBarHidden() {
      this.gropCrossPlatform.toggleSideBar = false;
      await this.getGroupCrossPlatform();
    },
    // async updateGroupCrossPlatformByGroupId() {
    //   let body = await this.groupApplicationSelected();
    //   let result = await groupService.updateGroupCrossPlatformAsync(
    //     this.GET_APPLICATION_SELECTED.id,
    //     this.id,
    //     body
    //   );
    //   if (result.status === 204) {
    //     await this.getGroupCrossPlatform();
    //     eventBus.$emit("info-modal", "Group cross platform deletion successful");
    //   } else {
    //     eventBus.$emit("error-modal", result);
    //   }
    // },
    // async removeGroupFromCrossPlatform(applicationId, groupId) {
    //   let index = this.groupCrossPlatform.applications.findIndex(
    //     (item) => item.application_id === applicationId
    //   );
    //   if (index > -1) {
    //     let groupIndex = this.groupCrossPlatform.applications[index].groups.findIndex(
    //       (item) => item.group_id === groupId
    //     );
    //     if (groupIndex > -1) {
    //       this.groupCrossPlatform.applications[index].groups.splice(groupIndex, 1);
    //     }
    //   }
    // },
  },
};
</script>

<style scoped>
.switches-channel {
  margin-top: 13px;
}
</style>
